export class Mdlusu {
    constructor(
        public UsuUsu: string,
        public UsuNom: string,
        public UsuClv: string,
        public UsuToken: string
    ) { }

}
